'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-react-gpt/~/react/react.js
 ** module id = 832
 ** module chunks = 0
 **/